import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod/v4';

import {
  FlowItemResponseSchema,
  FlowListResponseSchema,
  CreateFlowItemRequestSchema,
  FlowListRequestSchema,
  UpdateFlowItemRequestSchema,
  UpdateFlowItemStatusRequestSchema,
} from './schemas.js';

export const listFlows = defaultClient.query({
  url: 'approval-service/v2/flows/' as const,
  method: 'POST',
  responseSchema: FlowListResponseSchema,
  requestSchema: FlowListRequestSchema,
});

export const listAvailableFlows = defaultClient.query({
  url: 'approval-service/v2/flows/available' as const,
  method: 'GET',
  responseSchema: FlowListResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const getFlow = defaultClient.query({
  url: 'approval-service/v2/flows/$flowId/' as const,
  method: 'GET',
  responseSchema: FlowItemResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const createFlow = defaultClient.mutation({
  url: 'approval-service/v2/flows/create/' as const,
  method: 'POST',
  requestSchema: CreateFlowItemRequestSchema,
  responseSchema: FlowItemResponseSchema,
});

export const updateFlow = defaultClient.mutation({
  url: 'approval-service/v2/flows/$flowId/' as const,
  method: 'PUT',
  requestSchema: UpdateFlowItemRequestSchema,
  responseSchema: FlowItemResponseSchema,
});

export const updateFlowStatus = defaultClient.mutation({
  url: 'approval-service/v2/flows/$flowId/archive/' as const,
  method: 'POST',
  requestSchema: UpdateFlowItemStatusRequestSchema,
  responseSchema: FlowItemResponseSchema,
});

export const deleteFlow = defaultClient.mutation({
  url: 'approval-service/v2/flows/$flowId/' as const,
  method: 'DELETE',
  responseSchema: z.unknown(),
});

export const duplicateFlow = defaultClient.mutation({
  url: 'approval-service/v2/flows/$flowId/duplicate/' as const,
  method: 'POST',
  responseSchema: FlowItemResponseSchema,
  clientOptions: { request: { snakeCaseQueryParams: true } },
});
